import React, { useMemo } from 'react';

import { Slider } from '@mui/material';
import { round } from 'mathjs';

import './AppRangeSlider.scss';
import { twMerge } from 'tailwind-merge';

function AppRangeSlider({
  min = 0,
  max = 100,
  value,
  valueUnits = '',
  valueLabel = '',
  otherValueLabel = '',
  onChange,
  labelOrientation = 'VERTICAL',
}: {
  min: number;
  max: number;
  value: number;
  valueUnits?: string;
  valueLabel?: string;
  otherValueLabel?: string;
  onChange: ({ value, percentage }: { value: number; percentage: number }) => void;
  labelOrientation?: 'HORIZONTAL' | 'VERTICAL';
}) {
  const handleChange = (val: number) => {
    const newPercent = (val / max) * 100;
    onChange({ value: round(val, 2), percentage: round(newPercent, 2) });
  };
  const marks = useMemo(() => {
    const percentagesMarks = [0, 25, 50, 75, 100];
    return percentagesMarks.map((percentageMark) => {
      const val = round((percentageMark / 100) * max, 2);
      return {
        value: (percentageMark / 100) * max,
        label: `${valueUnits === '$' ? valueUnits : ''}${val}${
          valueUnits !== '$' ? valueUnits : ''
        }`,
      };
    });
  }, []);

  return (
    <div className="py-0 app-range-slider w-full flex flex-col">
      <div className="flex w-full px-5  ">
        <Slider
          min={min}
          max={max}
          step={0.1}
          marks={[...marks]}
          size="medium"
          className=""
          value={value}
          onChange={(event: any, newValue: any) => {
            handleChange(newValue);
          }}
        />
      </div>

      <div className={twMerge('flex', labelOrientation === 'VERTICAL' ? 'flex-col' : 'flex-row')}>
        <div className="flex text-sm ">
          <div className="">
            <span className="">{valueLabel || 'Value'}:</span>{' '}
            <span className={'PRIMARY_600-CLR'}>
              <span className="font-bold">
                {valueUnits === '$' ? valueUnits : ''}
                {value}
              </span>
              {valueUnits !== '$' ? valueUnits : ''}
            </span>
          </div>
        </div>
        <div
          className={twMerge('flex text-sm ', labelOrientation === 'VERTICAL' ? ' mt-1' : 'ml-5')}>
          {otherValueLabel && (
            <div className="">
              <span className="">{otherValueLabel || 'Value'}:</span>{' '}
              <span className={'SUCCESS_600-CLR'}>
                <span className="font-bold">
                  {valueUnits === '$' ? valueUnits : ''}
                  {round(max - value, 2)}
                </span>
                {valueUnits !== '$' ? valueUnits : ''}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AppRangeSlider;
